/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type SbRespFollowSearchBanner_user = {| |};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespFollowSearchBanner_user",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedFollowSearchBanner_user",
      "args": null
    }
  ],
  "type": "User"
};

module.exports = fragment;
